import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aplicativo',
  templateUrl: './aplicativo.component.html',
  styleUrls: ['./aplicativo.component.scss'],
})
export class AplicativoComponent implements OnInit {
  posicaoY = 0;
  containerActive = false;
  fmsg: FormGroup;
  beneficios = [
    {
      beneficio: 'INVESTIMENTO QUE CABE NO SEU BOLSO',
      img: 'investimentoquecabenobolso.svg',
    },
    { beneficio: 'SEM LIMITE DE ACESSOS', img: 'semlimitedeacesso.svg' },
    {
      beneficio: 'ORÇAMENTOS PERSONALIZADOS EM MINUTOS',
      img: 'orcamentoemminutos.svg',
    },
    { beneficio: 'PROJETOS PARA TÊMPERA ', img: 'projetosparatempera.svg' },
    { beneficio: 'CENTENAS DE TIPOLOGIAS', img: 'centenasDeTipologias.svg' },
    {
      beneficio: 'INVESTIMENTO QUE CABE NO SEU BOLSO',
      img: 'investimentoquecabenobolso.svg',
    },
    { beneficio: 'LISTA DE MATERIAIS PARA OBRA', img: 'listaDeMateriais.svg' },
    {
      beneficio: 'GERENCIAMENTO COMPLETO DA SUA VIDRAÇARIA PELO CELULAR',
      img: 'fornecedorguia.svg',
    },
    { beneficio: 'CONTROLE FINANCEIRO', img: 'controlefinanceiro.svg' },
    { beneficio: 'ANÚNCIO', img: 'anuncio.svg' },
    {
      beneficio: 'INVESTIMENTO QUE CABE NO SEU BOLSO',
      img: 'investimentoquecabenobolso.svg',
    },
    { beneficio: 'CONTROLE DE TAREFAS', img: 'controledetarefas.svg' },
    { beneficio: 'GUIA DE FORNECEDORES', img: 'fornecedor.svg' },
    { beneficio: 'MV UNIVERSIDADE', img: 'mvuniversidade.svg' },
    {
      beneficio: 'INVESTIMENTO QUE CABE NO SEU BOLSO',
      img: 'investimentoquecabenobolso.svg',
    },
    { beneficio: 'TREINAMENTOS', img: 'treinamento.svg' },
  ];

  avaliacoes = [
    {
      img: 'https://play-lh.googleusercontent.com/a-/AOh14GgDxRY7TUGKQCbl3OObp_bElAg-Sm0TdCK5iFqO7g=w48-h48-n-rw',
      nomeCliente: 'Eliezer Gonçalves Dos Santos',
      comentario:
        'Excelente app... Sou cliente a mais de ano. Sistema muito prático de manuseio, e bem completo em projetos da linha de temperado! Todos os meses estão acrescentando novos projetos, aperfeiçoando o app. E o que mais me impressiona e o suporte, muito rápido no retorno e em resolver a questão, nunca demoraram mais q 1h pra me darem um retorno! Parabéns!!! 👏👏👏👏',
      resposta:
        'Eliezer, a sua avaliação é muito importante para nós, é a maneira que temos para afirmar se estamos indo no caminho certo. Obrigado!!',
      likes: 8,
    },
    {
      img: 'https://play-lh.googleusercontent.com/a/AATXAJwH0SCwmt76uW4eiD8Wsj6W9qpr3qMrI3clqAiL=w48-h48-n-rw-mo',
      nomeCliente: 'Lucas torres',
      comentario:
        'Sou Dinho da sp Norte soluçães ,eu não consigo dizer o quanto este app tem me ajudado , adiantar na hora de manda imail projeto de execução de obra em fim pago com muito gosto e fantástico',
      resposta:
        'Lucas, obrigado, suas palavras são como uma vitamina, ajuda a sustentar e fortalecer nosso trabalho.',
      likes: 6,
    },
    {
      img: 'https://play-lh.googleusercontent.com/a-/AOh14Gj2N8xhSvLVe1-klMXCHEZMN2SYEe31eyyGwrvQ7A=w48-h48-n-rw',
      nomeCliente: 'Gabriel Zahdi',
      comentario:
        'Ótimo App, muito rápido e fácil de trabalhar. Agiliza muito a rotina para elaborar ou alterar orçamentos, possibilita personalização da logomarca do orçamento tornando uma apresentação muito profissional. Atendimento do suporte é muito rápido e objetivo, as solicitações são rapidamente atendidas. Recomendo!!!',
      resposta:
        'Gabriel, propaganda igual a sua não precisamos de outra rsrsrrs, muito obrigado por seu feedback é gratificante trabalhar para pessoas assim, como você.',
      likes: 11,
    },
  ];

  constructor(private fb: FormBuilder) {}

  @HostListener('window:scroll', ['$event'])
  ngOnInit(): void {
    //this.activeMenu()
    const scroll = addEventListener('scroll', () => {
      //this.activeMenu()
      this.posicaoY = window.pageYOffset;
    });

    this.criarFormMsg();

    /* VanillaTilt.init(<any>document.querySelectorAll('.card-conquista'), {
      max: 50,
      speed: 500,
      perspective: 500
    }) */
  }

  /* activeMenu() {
    const li = document.querySelectorAll('.nav-link');
    const sec = document.querySelectorAll('section');
    let len = sec.length;
    console.log(sec[len])
    while (--len && window.scrollY < sec[len].offsetTop) { }
    li.forEach(ltx => ltx.classList.remove('ativado'));
    li[len].classList.add('ativado');
  } */
  criarFormMsg() {
    this.fmsg = this.fb.group({
      nome: [null, Validators.required],
      msg: ['Gostaria de falar com um atendente'],
    });
  }

  irparaotopo() {
    window.scrollTo(0, 0);
  }

  clicked(event: any) {
    let liActive = document.querySelector('.ativado');
    liActive?.classList.remove('ativado');

    event.target.classList.add('ativado');
  }

  btnDownload() {
    if (/Mobi/.test(navigator.userAgent)) {
      console.warn('mobile');
      if (/Android/i.test(navigator.userAgent)) {
        window.open(
          'https://play.google.com/store/apps/details?id=br.com.zemt.zemtVidraceiro',
          '_blank'
        );
      } else {
        window.open(
          'https://apps.apple.com/br/app/meu-vidraceiro/id1479886116',
          '_blank'
        );
      }
    } else {
      window.open('https://app.meuvidraceiro.com.br', '_blank');
    }
  }

  submitWhatsapp() {
    if (this.fmsg.get('msg').value) {
      let msg = `Olá meu nome é ${this.fmsg.get('nome').value}\n${
        this.fmsg.get('msg').value
      }`;
      let url = `https://api.whatsapp.com/send?L=pt&phone=5531994022464&text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, '_blank');
    } else {
      /* this.fmsg.markAllAsTouched() */
      let msg = `Gostaria de falar com um atendente`;
      let url = `https://api.whatsapp.com/send?L=pt&phone=5531994022464&text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, '_blank');
    }
  }

  bgWhite() {
    if (this.posicaoY == 0) {
      window.scrollTo(1, 1);
    }
  }
}
